import CardWrapper from '../../components/wrapper/card';
import FilesComponent from '../../components/files';
import React from 'react';
import { settingSelectedFile } from '../../redux/slices/file';
import TasksComponent from '../../components/tasks';
import { a11yProps, CustomTabPanel } from '../deals';
import { AppDispatch, RootState } from '../../redux/store';
import { settingAddingTask, settingSelectedBoardList, settingSelectedBoardTaskDetail, settingSelectedTab, settingViewTaskItemDetail } from '../../redux/slices/task';
import { settingSelectedFolder, settingSelectedFolderForEdit } from '../../redux/slices/folder';
import { Tab, Tabs } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

const TasksAndFilesPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedTab } = useSelector((state: RootState) => state.task);

  const handleChange = (event: React.SyntheticEvent, newValue: 0 | 1) => {
    console.log(event);
    dispatch(settingSelectedBoardList(null));
    dispatch(settingSelectedBoardTaskDetail(null));
    dispatch(settingAddingTask(false));
    dispatch(settingViewTaskItemDetail(false));
    dispatch(settingSelectedFile(null));
    dispatch(settingSelectedFolder(false));
    dispatch(settingSelectedFolderForEdit(null));
    dispatch(settingSelectedTab(newValue));
  };

  return (
    <CardWrapper minHeight="80vh" overflow="auto">
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label="Task and Files details tabs"
      >
        <Tab
          label="Tasks"
          {...a11yProps(0)}
        />
        <Tab
          label="Files"
          {...a11yProps(1)}
        />
      </Tabs>

      <CustomTabPanel value={selectedTab} index={0}>
        {selectedTab === 0 && <TasksComponent />}
      </CustomTabPanel>

      <CustomTabPanel value={selectedTab} index={1}>
        {selectedTab === 1 && <FilesComponent />}
      </CustomTabPanel>
    </CardWrapper>
  );
};

export default TasksAndFilesPage;